export enum DocumentModal {
  ADD_FOLDER = 1,
  ADD_FILE = 2,
  EDIT = 3,
  DELETE = 4,
  MOVE = 5,
}

export enum InquiryModal {
  ADD = 1,
  EDIT = 2,
  DELETE = 3,
}

export enum AttachmentModal {
  FOLDER = 1,
  FILES = 2,
  DELETE = 3,
  UPDATE = 4,
}
